export default "__VITE_ASSET__Cp$IvX4u__"